module.exports = __webpack_public_path__ + "static/media/aetna.05dfaf0b.png";